var LogoVariants;
(function (LogoVariants) {
    LogoVariants["PRIMARY"] = "primary";
    LogoVariants["SECONDARY"] = "secondary";
    LogoVariants["TERTIARY"] = "tertiary";
    LogoVariants["QUATERNARY"] = "quaternary";
    LogoVariants["QUINARY"] = "quinary";
})(LogoVariants || (LogoVariants = {}));
var LogoSizes;
(function (LogoSizes) {
    LogoSizes["SMALL"] = "small";
    LogoSizes["MEDIUM"] = "medium";
    LogoSizes["LARGE"] = "large";
})(LogoSizes || (LogoSizes = {}));
var LogoColorModes;
(function (LogoColorModes) {
    LogoColorModes["LIGHT"] = "light";
    LogoColorModes["DARK"] = "dark";
})(LogoColorModes || (LogoColorModes = {}));
var LogoVersions;
(function (LogoVersions) {
    LogoVersions["COMPANY"] = "company";
    LogoVersions["ENTERPRISE"] = "enterprise";
})(LogoVersions || (LogoVersions = {}));
export { LogoVariants, LogoSizes, LogoColorModes, LogoVersions, };
//# sourceMappingURL=Logo.types.js.map